if ( $(window).width() > 800 ) {
  $('.product-list,.slideshow-slider').slick({
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
     dots: true,
     responsive: [{
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
          arrows:true,
        }},
        {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }},
       {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }}]
  });
  $('.left').click(function(){
    $('.product-list').slick('slickPrev');
  })

  $('.right').click(function(){
    $('.product-list').slick('slickNext');
  })
} else {
	var display_cards= $('#loadbutton').val();
  	$("#featured-product .single-product").slice(0, display_cards).show();
    $("#featured-product #loadMore").on("click", function(e){
      e.preventDefault();
      $("#featured-product .single-product:hidden").slice(0, display_cards).fadeIn().addClass("show").removeClass("filter_active_hide");
      if($("#featured-product .single-product:hidden").length == 0){
        $("#featured-product #loadMore").hide
      }
    });  	
}


$('.home-slider.slider_section').slick({
  infinite: true,
  slidesToShow: 1, // Shows a three slides at a time
  slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
  arrows: true, // Adds arrows to sides of slider
  prevArrow:"<div class='left'><img src='https://cdn.shopify.com/s/files/1/1092/6700/files/left-icon.png?v=1766419783' alt='left-arrow'/></div>",
  nextArrow:"<div class='right'><img src='https://cdn.shopify.com/s/files/1/1092/6700/files/right-icon.png?v=1766419783' alt='right-arrow'/></div>",
  dots: false // Adds the dots on the bottom
});

// Slideshow Section Slider JS Start
$('.custom-slideshow.custom_slider_section').slick({
  infinite: true,
  slidesToShow: 1, // Shows a three slides at a time
  slidesToScroll: 1, // When you click an arrow, it scrolls 1 slide at a time
  arrows: true, // Adds arrows to sides of slider
  prevArrow:"<div class='left'><img src='https://cdn.shopify.com/s/files/1/1092/6700/files/left-icon.png?v=1766419783' alt='left-arrow' width='13' height='22'/></div>",
  nextArrow:"<div class='right'><img src='https://cdn.shopify.com/s/files/1/1092/6700/files/right-icon.png?v=1766419783' alt='right-arrow' width='13' height='22'/></div>",
  adaptiveHeight: true,
  dots: false // Adds the dots on the bottom
});
// Slideshow Section Slider JS End

// Loading Lazy Removed JS Start 
document.addEventListener("DOMContentLoaded", function() {
  var banners = document.querySelectorAll(".custom-slideshow .slideshow-image img");
  banners[0].removeAttribute("loading");
  });
// Loading Lazy Removed JS End 